import React from "react";
import { Card } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

interface RevenueData {
  month: string;
  earning: number;
  expense: number;
}

const config: RevenueData[] = [
  { month: "Jan 2025", earning: 150, expense: -90 },
  { month: "Feb 2025", earning: 280, expense: -130 },
  { month: "Mar 2025", earning: 200, expense: -270 },
  { month: "Apr 2025", earning: 140, expense: -150 },
  { month: "May 2025", earning: 180, expense: -180 },
  { month: "Jun 2025", earning: 260, expense: -110 },
  { month: "Jul 2025", earning: 100, expense: -250 },
  { month: "Aug 2025", earning: 80, expense: -180 },
  { month: "Sep 2025", earning: 190, expense: -290 },
  { month: "Oct 2025", earning: 290, expense: -150 },
  { month: "Nov 2025", earning: 170, expense: -230 },
  { month: "Dec 2025", earning: 220, expense: -100 },
];

const RevenueReport: React.FC = () => {
  return (
    <Card className="rounded-xl shadow-sm mt-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-[16px] font-semibold text-gray-800">
          Revenue Report
        </h2>

        {/* Custom Legend */}
        <div className="flex gap-4 text-sm">
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-sm bg-[#6D6AF8]" />
            <span className="text-gray-500">Earning</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-sm bg-[#FF9F2D]" />
            <span className="text-gray-500">Expense</span>
          </div>
        </div>
      </div>

      {/* Chart */}
      <div className="w-full h-[360px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={config} barGap={12}>
            <CartesianGrid
              strokeDasharray="4 4"
              vertical={false}
              stroke="#E5E7EB"
            />

            <XAxis
              dataKey="month"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#667085", fontSize: 12 }}
            />

            <YAxis
              domain={[-300, 300]}
              ticks={[-300, -200, -100, 0, 100, 200, 300]}
              axisLine={false}
              tickLine={false}
              tick={{
                fill: "#667085",
                fontSize: 12,
              }}
              tickFormatter={(val) =>
                val === 0 ? "0" : `${Math.abs(val)}k`
              }
            />

            <Tooltip cursor={{ fill: "transparent" }} />

            {/* Earning */}
            <Bar
              dataKey="earning"
              fill="#6D6AF8"
              barSize={10}
              radius={[10, 10, 10, 10]}
            />

            {/* Expense */}
            <Bar
              dataKey="expense"
              fill="#FF9F2D"
              barSize={10}
              radius={[10, 10, 10, 10]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default RevenueReport;
